import React, {useState, useEffect} from 'react';
import { Navegation } from '../../Components/Navegation';
import ColeccionList from '../../Components/ColeccionList';
import ColeccionServices, {iColeccion} from '../../Services/ColeccionServices';
import GA from '../../GoogleAnalytics';
import './index.scss';

export default () => {

    const [listColeccion, setListColeccion ] = useState<iColeccion[]>([]);
    const [ isLoading , setIsLoading ] = useState(false);

    useEffect(() => {
        setIsLoading(true)
        ColeccionServices.getAll().then(({data}:any) => {
            if(data.data){
                setListColeccion(data.data);
            }
        }).finally(() => {
            setIsLoading(false)
        })
    }, [])

    return (
        <div>
            <GA.RouteTracker title={`Recursos Pedagógicos`}/>
            <Navegation title={`RECURSOS PEDAGÓGICOS`} />
            <p className="p_recursos__pharagraph e-p4 e-text-light">
                El Museo de Arte de Lima- MALI y Espacio Fundación Telefónica vuelven a unir esfuerzos en el 2020 para desarrollar el proyecto Irradia, programa de actividades y exposiciones artísticas que gira en torno a tres ejes: Arte + Tecnología, Arte+ Espacio Público y Arte + Educación. 
                <br/><br/>
                Irradia. Arte+Educación es una iniciativa conjunta basada en el desarrollo de la propuesta: ARCHI para aprender, que incluye recursos educativos de libre descarga para complementar el proceso de enseñanza-aprendizaje en el aula, incorporando el análisis de obras de arte como un recurso didáctico.
                <br/><br/>
                El programa surgió en el año 2005 como una iniciativa conjunta de Fundación Telefónica y el Museo de Arte de Lima-MALI, para crear un espacio de aprendizaje en torno a la historia del arte peruano, que contribuya a llenar el gran vacío existente sobre esta disciplina en la currícula escolar.
                <br/><br/>
                Arte para Aprender se concibe como un programa educativo integral orientado a promover la utilización del arte como un medio que sirva de punto de partida para la integración de otras disciplinas. Para ello se brindaron herramientas para que el docente desarrolle actividades asociadas a las líneas de formación de la currícula escolar vigente en esos años. Para diseñar el programa se convocó a los principales especialistas del Perú, que incluyó la producción de textos escolares, documentos para Internet, materiales pedagógicos para maestros, juegos educativos y talleres para escolares y jóvenes universitarios; acompañados de un intenso programa de actividades.
                <br/><br/>
                Las exposiciones producidas por el proyecto se presentaron en el Centro Fundación Telefónica, con obras procedentes de las colecciones del MALI. Cada muestra exploraba aspectos distintos de nuestra historia del arte, desde la época precolombina hasta la creación más reciente.
            </p>
            
        </div>
    )
}